// tslint:disable:no-commented-code
// tslint:disable:only-arrow-functions
// tslint:disable:no-any
import { FiltersChangedEvent } from '@epicuro-next/features/dashboard';
import {
  IDynamicBindableValue,
  IDynamicItemValue,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import * as loadingStateWrapperHelpers from '../../loading-state-wrapper-helpers';
import {
  getPanelTrackingIdProperty,
  PanelTrackingIdConstants,
} from '../../panel-tracking-id';
import {
  hasData,
  hasNoItems,
  httpBodyToProductData,
  productData,
} from '../../product-data';
import { getServingConfigProperty } from '../../serving-config';

type PropertiesType = {
  fromDate?: string;
  toDate?: string;
  brandOrg: string | string[];
  category?: string;
  filterMissingImages?: boolean;
};

export function getBestPerformingArticles(
  panelNameProvider: IDynamicBindableValue,
  brandOrgProvider: IDynamicBindableValue,
  lastSelectedFilterValuesProvider: IDynamicBindableValue,
  filterMissingImages: IDynamicItemValue,
): IDynamicBindableValue {
  return {
    provider: 'HttpBodyProvider',
    property: {
      values: [
        panelNameProvider,
        brandOrgProvider,
        lastSelectedFilterValuesProvider,
        filterMissingImages,
      ],
      transform: function ([
        panelName,
        brandOrg,
        filterValues,
        doFilterMissingImages,
      ]: [string, string, FiltersChangedEvent, boolean]): string {
        const properties: PropertiesType = {
          brandOrg,
          filterMissingImages: doFilterMissingImages,
        };

        if (filterValues.dateRange !== undefined) {
          properties.fromDate = filterValues.dateRange.from;
          properties.toDate = filterValues.dateRange.to;
        }

        if (
          filterValues.categories !== undefined &&
          filterValues.categories.length > 0
        ) {
          properties.category = filterValues.categories[0];
          if (filterValues.categories.length > 1) {
            console.warn(
              'Only 1 category at a time is supported. The first category will be used.',
            );
          }
        }

        const body = {
          panelType: panelName,
          properties,
        };
        const bodyJson = JSON.stringify(JSON.stringify(body));

        const headers = {
          accept: 'application/json, text/plain, */*',
          'accept-language': 'en-US',
          'content-type': 'application/json',
        };
        const headersJson = JSON.stringify(headers);
        const url = '/api/v2/recommendation/suggest';
        const method = 'POST';
        const fetchString = `fetch("${url}", { "headers": ${headersJson}, "body": ${bodyJson}, "method": "${method}" });`;
        return fetchString;
      }.toString(),
    },
    transform: httpBodyToProductData.toString(),
    wrapWithLoadingState: true,
  };
}

export function getBrandOrg(): IDynamicBindableValue {
  return {
    provider: 'GlobalStoreProviderService',
    property: {
      once: true,
      paths: [
        'sites.currentSite.brandId',
        'accounts.activeAccount.brandOrganisations',
      ],
    },
    transform: function ([brandId, brandOrganisations]: [
      string,
      { brandId: string; brandOrganisationId: string }[],
    ]): string {
      const brandOrg = brandOrganisations.find(
        // tslint:disable-next-line:no-any
        (bo: any) => bo.brandId === brandId,
      );
      return brandOrg?.brandOrganisationId ?? 'N/A';
    }.toString(),
  };
}

export function getDataForBestPerformingArticles(
  panelNameProvider: IDynamicBindableValue,
  lastSelectedFilterValuesProvider: IDynamicBindableValue,
  panelStyleConstants: PanelTrackingIdConstants,
  filterMissingImages: IDynamicItemValue,
) {
  const brandOrgKey = 'brandOrg';
  const brandOrgProvider: IDynamicBindableValue = {
    provider: 'self',
    property: brandOrgKey,
  };

  return {
    [brandOrgKey]: getBrandOrg(),
    loadingStateWrapper: getBestPerformingArticles(
      panelNameProvider,
      brandOrgProvider,
      lastSelectedFilterValuesProvider,
      filterMissingImages,
    ),
    isLoading: loadingStateWrapperHelpers.isLoading(),
    productData: productData(),
    hasError: loadingStateWrapperHelpers.hasError(),
    hasData: hasData('self'),
    hasNoItems: hasNoItems(),
    ...getServingConfigProperty(),
    ...getPanelTrackingIdProperty(panelStyleConstants),
  };
}
